import { TableHead, TableRow, TableCell, styled } from '@mui/material';
import React from 'react';

const CustomTableHead = styled(TableHead)({
  backgroundColor: 'black',
  '& th': {
    color: 'white',
    cursor: 'pointer',
  },
});

export interface ColumnConfig<TSort extends string> {
  id: TSort;
  label: string;
  width?: string;
  align?: 'left' | 'center' | 'right';
  sortable?: boolean;
}

interface SortableTableHeadProps<TSort extends string> {
  columns: readonly ColumnConfig<TSort>[];
  sortBy: TSort;
  sortDirection: 'asc' | 'desc';
  onSort: (column: TSort) => void;
  prependCell?: React.ReactNode;
  appendCell?: React.ReactNode;
}

export function SortableTableHead<TSort extends string>({
  columns,
  sortBy,
  sortDirection,
  onSort,
  prependCell,
  appendCell,
}: SortableTableHeadProps<TSort>) {
  return (
    <CustomTableHead>
      <TableRow>
        {prependCell && <>{prependCell}</>}
        
        {columns.map((col) => (
          <TableCell
            key={col.id}
            align={col.align || 'left'}
            onClick={() => col.sortable !== false && onSort(col.id)}
            sx={{ 
              width: col.width,
              cursor: col.sortable !== false ? 'pointer' : 'default' 
            }}
          >
            {col.label}
            {col.sortable !== false && sortBy === col.id && (
              <span style={{ marginLeft: '4px' }}>
                {sortDirection === 'asc' ? '▲' : '▼'}
              </span>
            )}
          </TableCell>
        ))}

        {appendCell && <>{appendCell}</>}
      </TableRow>
    </CustomTableHead>
  );
}